<div class="gallery-wrapper" *ngIf="images">
  <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li data-target="#carouselExampleIndicators" *ngFor="let image of images;let index=index"
        attr.data-slide-to="{{index}}" [ngClass]="{'active':index==selectedIndex}"></li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let image of images;let index=index"
        [ngClass]="{'active':index==selectedIndex}">
        <img [src]="image" class="d-block w-100" alt="...">
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
  <div class="thumbnail-wrapper">
    <div class="gallery" *ngFor="let image of images;let index=index" [ngClass]="{'active':index==selectedIndex}">
      <span (click)="setImage(index)">
        <img [src]="image" alt="Scada" width="150" height="100">
      </span>
    </div>
  </div>
</div>